import { Group, Text, ActionIcon, Menu, Avatar, useMantineColorScheme, useComputedColorScheme } from "@mantine/core";
import { IconMoon, IconSun, IconLogout } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext.js";
import { LanguageSwitcher } from "../components/LanguageSwitcher.js";

export function Header() {
  const { setColorScheme } = useMantineColorScheme();
  const scheme = useComputedColorScheme("light");
  const { user, logout } = useAuth();
  const { t } = useTranslation();

  const logoSrc = scheme === "dark" ? "/logo-dark.png" : "/logo-light.png";
  const initials = user
    ? user.name.split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase()
    : "?";

  return (
    <Group justify="space-between" px="md" h="100%">
      <Group gap="sm">
        <img src={logoSrc} alt="" width={28} height={28} />
        <Text fw={600} size="sm">ISMS · axxalon</Text>
      </Group>
      <Group gap="xs">
        <LanguageSwitcher />
        <ActionIcon
          variant="subtle"
          aria-label={t("nav.header.toggleTheme")}
          onClick={() => setColorScheme(scheme === "dark" ? "light" : "dark")}
        >
          {scheme === "dark" ? <IconSun size={18} /> : <IconMoon size={18} />}
        </ActionIcon>
        {user && (
          <Menu position="bottom-end">
            <Menu.Target>
              <Group gap="xs" style={{ cursor: "pointer" }}>
                <Avatar size={28} radius="xl" color="brand">{initials}</Avatar>
                <Text size="sm">{user.name}</Text>
              </Group>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item leftSection={<IconLogout size={14} />} onClick={() => void logout()}>
                {t("common.action.logout")}
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </Group>
    </Group>
  );
}
